import { Box, Paper, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export default function ActionHeaderCard({
  title,
  description,
  icon = null,
  action = null,
  children = null,
  sx = {},
  contentSx = {},
}) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const inner = (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: { xs: "stretch", sm: "center" },
          gap: 1.5,
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          ...contentSx,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.4,
            minWidth: 0,
            flex: 1,
          }}
        >
          <Box sx={{ minWidth: 0 }}>
            <Typography
              sx={{
                fontWeight: 900,
                fontSize: 18,
                lineHeight: 1.15,
                letterSpacing: 0.1,
              }}
            >
              {title}
            </Typography>

            {description ? (
              <Typography
                variant="body2"
                sx={{
                  opacity: 0.7,
                  mt: 0.4,
                  lineHeight: 1.35,
                }}
              >
                {description}
              </Typography>
            ) : null}
          </Box>
        </Box>

        {action ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: { xs: "stretch", sm: "flex-end" },
              flexShrink: 0,
            }}
          >
            {action}
          </Box>
        ) : null}
      </Box>

      {children ? <Box sx={{ mt: 2 }}>{children}</Box> : null}
    </>
  );

  if (isMobile) {
    return <Box sx={sx}>{inner}</Box>;
  }

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: 3,
        border: isDark
          ? "1px solid rgba(255,255,255,0.08)"
          : "1px solid rgba(0,0,0,0.08)",
        background: isDark
          ? "rgba(255,255,255,0.04)"
          : "rgba(255,255,255,0.75)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
        ...sx,
      }}
    >
      {inner}
    </Paper>
  );
}
